<avs-route-station-settings [activeRouteStation]="activeRouteStation" [dataEndChannels]="dataEndChannel"
    (dataEndChannelRefresh)="onRefreshDataEndChannel()" [dataEndChannelErrors]="dataEndChannelErrors"
    (dataEndChannelErrorsRefresh)="onRefreshDataEndChannelErrors()" [activeGroup]="activeGroup" [activeProjectsOnly]="true">
</avs-route-station-settings>
<p *ngIf="!activeRouteStation" class="mt-3 fw-semibold text-secondary">Keine Station ausgewählt!</p>